var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTerra = function SvgTerra(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.765.721C6.107.22 7.617.218 8.984.631c1.779.552 3.281 1.895 4.066 3.58.216.48.424.981.444 1.515-1-.58-2.096-.956-3.195-1.298C8.54 3.794 6.7 3.354 5.038 2.483c-.388-.231-.881-.468-.987-.95-.042-.418.399-.65.714-.812ZM.715 4.777c.388-1.054 1.025-2.032 1.89-2.758.22 1.81.99 3.558 2.262 4.873 1.525 1.585 3.697 2.557 5.907 2.52.878.028 1.736-.175 2.592-.338-.842 3.043-4.177 5.063-7.268 4.577-1.865-.238-3.587-1.343-4.626-2.902C.3 9.026.004 6.737.715 4.777Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.298 4.428c1.1.343 2.196.719 3.196 1.299l.067.035c.093.698.16 1.41.037 2.108-.503-.213-.91-.587-1.337-.919-.82-.682-1.658-1.464-1.963-2.523Z",
    fill: "#060710"
  })));
};
export default SvgTerra;